import React, { useState, useEffect, useContext } from 'react';
import { Table } from 'rsuite';
import { Button, Pagination } from "react-bootstrap";
import Assets from "../../constants/image";
import { ArrowLeftBold, ArrowRight, DoubleArrowBold, EditIcon } from "../ThemeSvgs";
import { Link } from 'react-router-dom';
import { FixedColumnContext, TableHeightContext } from "../../App";

const EmployeesTable = (props) => {
    //Table height and fixed columns of table calculated on context.
    const [tableHeight, setTableHeight] = useContext(TableHeightContext);
    const [fixedState, setFixedState] = useContext(FixedColumnContext);
    const { Column, HeaderCell, Cell } = Table; // Importing components from Rsuite Table
    const [data, setData] = useState(props?.defaultData); //Set the default data to Data state
    const [loading, setLoading] = useState(false); //For Loading
    const [sortColumn, setSortColumn] = useState(); //For Sorting Column
    const [sortType, setSortType] = useState(); //For Sorting column by type
    const [limit, setLimit] = useState(10); //For Pagination
    const [page, setPage] = useState(1);//For Pagination

    /** For Pagination */
    const handleChangeLimit = dataKey => {
        setPage(1);
        setLimit(dataKey);
    };
    /** For Sorting */
    const getData = () => {
        if (sortColumn && sortType) {
            return data.sort((a, b) => {
                let x = a[sortColumn];
                let y = b[sortColumn];
                if (typeof x === 'string') {
                    x = x.charCodeAt();
                }
                if (typeof y === 'string') {
                    y = y.charCodeAt();
                }
                if (sortType === 'asc') {
                    return x - y;
                } else {
                    return y - x;
                }
            });
        }
        return data;
    };

    const handleSortColumn = (sortColumn, sortType) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 500);
    };
    const handleEditClick = () => {
        props?.setEditPopup(true)
    }
    // Action Cell 
    const ActionCell = ({ rowData, dataKey, onClick, ...props }) => {
        return (
            <Cell {...props}>
                <div className="editBtn">
                    <Button
                        onClick={() => {
                            handleEditClick()
                        }}
                        className='EditIcon me-2'
                    >
                        <EditIcon />
                    </Button>
                </div>
            </Cell>
        );
    };

    return (
        <>
            <Table
                data={getData()}
                locale={{
                    emptyMessage: (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: `<div class="text-center">
                                    <div class="nodatafolder mb-2">
                                        <img src="${Assets.noDataFolder}" alt="No data found" />
                                    </div>
                                    <p>No Data Found</p>
                                    </div>`
                            }}
                        />
                    )
                }}
                height={tableHeight}
                headerHeight={72}
                hover={false}
                loading={loading}
                cellBordered={false}
                sortColumn={sortColumn}
                sortType={sortType}
                onSortColumn={handleSortColumn}
            >
                <Column flexGrow={1} sortable>
                    <HeaderCell>Employees ID</HeaderCell>
                    <Cell dataKey="id" />
                </Column>
                <Column flexGrow={1} sortable>
                    <HeaderCell>Name</HeaderCell>
                    <Cell dataKey="employeeName" />
                </Column>
                <Column flexGrow={1} sortable>
                    <HeaderCell>Start Date</HeaderCell>
                    <Cell dataKey="startDate" />
                </Column>
                <Column flexGrow={1} sortable>
                    <HeaderCell>Birth Date</HeaderCell>
                    <Cell dataKey="birthDate" />
                </Column>
                {/* <Column flexGrow={1} sortable>
                    <HeaderCell>Store</HeaderCell>
                    <Cell dataKey="store" />
                </Column> */}
                <Column flexGrow={1} sortable>
                    <HeaderCell>Term Date</HeaderCell>
                    <Cell dataKey="termDate" />
                </Column>

                <Column flexGrow={1} align="left">
                    <HeaderCell className="text-left">Action</HeaderCell>
                    <ActionCell dataKey="id" />
                </Column>
            </Table>
            <div className="pagiantion-box d-flex justify-content-end">
                <Pagination>
                    <Pagination.First>
                        <ArrowLeftBold />
                    </Pagination.First>
                    <Pagination.Prev className="doubleArrow rotate180" >
                        <DoubleArrowBold />
                    </Pagination.Prev>
                    <Pagination.Item>{1}</Pagination.Item>
                    <Pagination.Item active>{2}</Pagination.Item>
                    <Pagination.Ellipsis />
                    <Pagination.Item>{100}</Pagination.Item>
                    <Pagination.Next >
                        <ArrowLeftBold />
                    </Pagination.Next>
                    <Pagination.Last className="doubleArrow" >
                        <DoubleArrowBold />
                    </Pagination.Last>
                </Pagination>
            </div>
        </>
    )
}

export default EmployeesTable